import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioBitacora from '../servicios/ServicioBitacora';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Calendar } from "primereact/calendar";
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicios/ServicioConstantes';
import { AutoComplete } from 'primereact/autocomplete';
class Bitacora extends Component {
        constructor() {
                super();

                this.state = {
                        valorencontrado: null,
                        erroresRequeridos: {},
                        bitacora: {},
                        usuarios: [],
                        paginacion: {
                                registrosPorPagina: 20,
                                clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TtBitacora',
                                join: ["twUsuario"],
                                conjunciones: {},
                                betweenPropertyName: null,
                                between: [],
                                session: false
                        },
                        first: 0,
                }

        }
        componentDidMount() {
                this.obtenerResultados();


        }
        validarFormularioFolioUsuario = (usuarios) => {
                
                const errores = {};
                if (usuarios.length===0)
                  errores.usuarios = "El usuario es requerido";
                return errores;
              }
        validarFormularioFolioUsuarioFechas = (usuarios, bitacora) => {
              
                const errores = {};
                if (usuarios.length===0)
                  errores.usuarios = "El usuario es requerido";
                  if (!bitacora.fechaFinal)
                  errores.fechaFinal = "Campo requerido";
                  if (!bitacora.fechaInicial)
                  errores.fechaInicial = "Campo requerido";
                return errores;
              }


       
        obtenerResultados = () => {
                const { paginacion } = this.state;
                servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
                        this.setState({ paginacion: response.data });
                });
        }
        onPage = (event) => {
                this.setState({
                        first: event.first
                });
                const { paginacion } = this.state;
                paginacion.numeroPagina = event.page;
                paginacion.registrosPorPagina = event.rows;
                servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
                        this.setState({ paginacion: response.data });
                });
        }
        asignarValoresObjeto = (event) => {
                servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
        }

        buscarLikeUsuario = (valor) => {
                setTimeout(() => {

                        if (valor.query.length === 0) {
                               
                        }
                        else {
                                servicioBitacora.buscarUsuario(valor.query.toUpperCase()).then((response) => {
                                        if (response.data === '') {
                                                this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: 'No existe informaci\u00f3n con los valores ingresados' });
                                                this.setState({ valorencontrado: response.data });
                                        } else {
                                                this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: "Valores encontrados" });
                                                this.setState({ valorencontrado: response.data });
                                        }
                                }).catch((error) => {
                                        this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
                                });
                        }

                }, 250);


        }
        buscarPorUsuario = () => {
                let { paginacion, usuarios } = this.state;
                
                const validacion = this.validarFormularioFolioUsuario(usuarios);
                this.setState({ erroresRequeridos: validacion });
                if (!Object.keys(validacion).length) {
                let nombrePropiedad = "alias_twUsuario.nombre";
                paginacion.conjunciones = {};
                paginacion.conjunciones[nombrePropiedad] = usuarios.nombre;
                this.setState({ paginacion: paginacion });
                this.obtenerResultados();
                }

        }
        buscarPorUsuarioFechas = () => {
                let { paginacion, usuarios , bitacora} = this.state;
                const validacion = this.validarFormularioFolioUsuarioFechas(usuarios, bitacora);
                this.setState({ erroresRequeridos: validacion });
                if (!Object.keys(validacion).length) {
                paginacion.betweenPropertyName = "fecha";
                paginacion.between = [bitacora.fechaInicial.getTime(), bitacora.fechaFinal.getTime()];
                paginacion.conjunciones = {};
                let nombrePropiedad = "alias_twUsuario.nombre";
                paginacion.conjunciones[nombrePropiedad] = usuarios.nombre;
                this.setState({ paginacion: paginacion });
                this.obtenerResultados();
    
                }
        }
        reiniciarConsultas = () =>{
                 
                this.setState({ usuarios:[],bitacora:{},erroresRequeridos:{} });    
        }


        render() {
                let { paginacion, inicio, bitacora, erroresRequeridos } = this.state;
                return (

                        <div>
                                <div className="p-grid">
                                        <Growl ref={(el) => (this.growl = el)} />
                                        <Card className="p-col-12 p-md-12">
                                                <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bolder' }}>
                                                        Bitácora
                    </h1>
                                                <div className="p-fluid p-grid">
                                                        <div className="p-col-12 p-md-4">

                                                        </div>
                                                </div>
                                        </Card>
                                        <Accordion class="p-accordion-header p-highlight" onTabOpen={this.reiniciarConsultas} onTabClose={this.reiniciarConsultas} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                                                <AccordionTab header="Buscar por usuario">
                                                        <div className="p-col-12 p-md-12">

                                                                <AutoComplete field="usuario" id="usuarios" value={this.state.usuarios} suggestions={this.state.valorencontrado} completeMethod={this.buscarLikeUsuario} size={30} minLength={1}
                                                                        onChange={(e) => this.setState({ usuarios: e.value })} className={erroresRequeridos.usuarios ? 'p-error' : ''} />
                                                                {erroresRequeridos.usuarios ? <div> <Message severity="error" text={erroresRequeridos.usuarios} /> </div> : null}

                                                                <Button onClick={this.buscarPorUsuario} icon="pi pi-search" label="Buscar" style={{
                                                                        textAlign: 'rigth', marginLeft: '20px', backgroundColor: '#d76b48',
                                                                        borderColor: '#d76b48'
                                                                }} ></Button>
                                                        </div>
                                                </AccordionTab>
                                                <AccordionTab header="Buscar por usuario y fecha">
                                                        <div className="p-fluid p-grid">
                                                                <div className="p-col-12 p-md-3">

                                                                        <AutoComplete field="usuario" id="usuarios" value={this.state.usuarios} suggestions={this.state.valorencontrado} completeMethod={this.buscarLikeUsuario} size={30} minLength={1}
                                                                                onChange={(e) => this.setState({ usuarios: e.value })} className={erroresRequeridos.usuarios ? 'p-error' : ''} />
                                                                        {erroresRequeridos.usuarios ? <div> <Message severity="error" text={erroresRequeridos.usuarios} /> </div> : null}
                                                                </div>
                                                                <div className="p-col-12 p-md-3">
                                                                        <Calendar placeholder="Fecha inicial" dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="bitacora.fechaInicial" name="bitacora.fechaInicial" value={bitacora.fechaInicial} onChange={(e) => { this.asignarValoresObjeto(e, false) }} />
                                                                        {erroresRequeridos.fechaInicial ? <div> <Message severity="error" text={erroresRequeridos.fechaInicial} /> </div> : null}
                                                                </div>
                                                                <div className="p-col-12 p-md-3">
                                                                        <Calendar placeholder="Fecha final" dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="bitacora.fechaFinal" name="bitacora.fechaFinal" value={bitacora.fechaFinal} onChange={(e) => { this.asignarValoresObjeto(e, false) }} />
                                                                        {erroresRequeridos.fechaFinal ? <div> <Message severity="error" text={erroresRequeridos.fechaFinal} /> </div> : null}
                                                                </div>
                                                                <div className="p-col-12 p-md-2">
                                                                        <Button onClick={this.buscarPorUsuarioFechas} icon="pi pi-search" label="Buscar" style={{
                                                                                textAlign: 'rigth', marginLeft: '20px', backgroundColor: '#d76b48',
                                                                                borderColor: '#d76b48'
                                                                        }}  ></Button>
                                                                </div>
                                                        </div>
                                                </AccordionTab>
                                        </Accordion>
                                        <Card className="p-col-12 p-md-12">
                                        <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
                                                        <Column field="twUsuario.usuario" header="Usuario" sortable={false} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                                                        <Column field="tipoMovimiento" header="Tipo Movimiento" sortable={false} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                                                        <Column field="descripcion" header="Descripción" sortable={false} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                                                        <Column body={(e) => servicioFormatos.formatearFechaString(e.fecha)} header="Fecha" sortable={false} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                                                </DataTable>
                                                <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={inicio} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
                                               
                                        </Card>
                                </div>
                        </div>
                );

        }
}
export default Bitacora;